import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateFormatPipe, Loader, LoaderSpinnerComponent } from '@aston/foundation';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ISubsidiaryAppliedUserDelegations, ISubsidiaryUser } from '../../models';

@Component({
    selector: 'middle-users-delegation-view.component',
    imports: [AsyncPipe, TranslateModule, DateFormatPipe, LoaderSpinnerComponent],
    templateUrl: './middle-users-delegation-view.component.html'
})
export class MiddleUsersDelegationViewModalComponent implements OnInit {
	@Input({ required: true }) user: ISubsidiaryUser;
	@Input({ required: true }) loader = Loader.empty();
	@Input({ required: true }) delegations$: Observable<ISubsidiaryAppliedUserDelegations>;
	@Input({ required: true }) loadDelegations: (userId: number) => void;
	@Input() roleLabelFn = t => `DataList.Columns.${t}`;

	@Output() submitForm: EventEmitter<void> = new EventEmitter();

	constructor(public activeModal: NgbActiveModal) {}

    ngOnInit() {
		this.loadDelegations(this.user.userId);
    }
}
